import GuildsContract from 'decentralized/contracts/GuildsContract.js';
import GuildSettingsContract from "decentralized/contracts/GuildSettingsContract.js";
import ethereum from 'decentralized/ethereum.js';
import {uuid} from 'uuidv4';
import EthereumUsers from 'decentralized/ethereumUsers.js';
import accounts from 'accounts/Accounts.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {GUILDS} from 'decentralized/transactions/contracts.js';
import {GUILD_SETTINGS} from 'decentralized/transactions/contracts.js';
import {NewGuildMemberRequest} from 'decentralized/EthereumEvents.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {NewGuildMemberRequestAccepted} from 'decentralized/EthereumEvents.js';
import {NewGuildMemberRequestRejected} from 'decentralized/EthereumEvents.js';
import {SampleCreated} from 'decentralized/EthereumEvents.js';
import {GuildKeyEncrypted} from 'decentralized/EthereumEvents.js';
import {
    UserLeftGuild,
    NewGuild} from 'decentralized/EthereumEvents.js';
import {SOUND} from 'constants/encrypted-content-types.js';
import GuildSamplesContract from 'decentralized/contracts/GuildSamplesContract.js';

let samplesContract = new GuildSamplesContract();
let guildSettingsAddress = new GuildSettingsContract().contractAddress;

let nameCache = {};

class Guilds {
    constructor(web3, crypto, encryption) {
        this.web3 = web3;
        this.contract = new GuildsContract().getContract(web3);
        this.users = new EthereumUsers(web3);
        this.crypto = crypto;
        this.encryption = encryption;
        this.guildKeyCache = {};
        this.guildIdCache = {};
        this.guildsWithAccess = undefined;
    }

    async initGuilds() {
        this.guilds = await this.getGuildsForUser();
        const account = await accounts.getAccount();
        if (account === undefined) {
            return;
        }
        
        if (!navigator.onLine) {
            return;
        }

        let ethereumQuery = new BackendQuery(this.contract.options.address)
            .from(NewGuild)
            .select('guildId')
            .where('user', account.toLowerCase())
            .watchQuery(() => {
               if (this.newGuildCallback) {
                    this.newGuildCallback();
                }
            });

        /*
        let guilds = await this.getGuildsWithAccess();
        guilds.forEach(({guildId}) => this.getGuildKey(guildId));
        */
    }

    saveGuildKey(guildId, guildKey) {
        this.guildKeyCache[guildId] = guildKey;
    }

    async getGuildKey(guildId) {
        if (guildId in this.guildKeyCache) {
            let x = this.guildKeyCache[guildId];
            return await x;
        }

        let promise = new Promise(async (resolve, reject) => {
            let dateA = new Date().getTime();
            if (guildId === undefined)  {
                let guilds = await this.getGuildsForUser();
                if (guilds.length === 0) {
                    // no guilds
                    resolve(undefined);
                    return;
                }
                guildId = guilds[0].guildId;
            }

            const account = await accounts.getAccount();
            if (account === undefined) {
                resolve(undefined);
                return;
            }
            
            console.log("gettinng gulkd key ecrypted");
            let results = await new BackendQuery(this.contractAddress)
                .from(GuildKeyEncrypted)
                .select('ipfsHash')
                .where('user', account.toLowerCase())
                .where('guildId', guildId)
                .executeQuery();

            console.log("results gguild=", results);
            if (results.length === 0) {
                delete this.guildKeyCache[guildId];
                resolve(undefined);
                return;
            }

            let ipfsHash = results[0].ipfsHash;
           
            let dateC = new Date().getTime();
            let encryptedContentMetadata = await this.encryption.getEncryptedContent(ipfsHash);
            if (encryptedContentMetadata === undefined) {
                encryptedContentMetadata = await this.encryption.getEncryptedContentSharedWithMe(ipfsHash);
            }
            console.log("encrypted content meta=", encryptedContentMetadata);
            let dateD = new Date().getTime();
            let time = dateD - dateC;
            if (encryptedContentMetadata === undefined) {
                delete this.guildKeyCache[guildId];
                resolve(undefined);
                return;
            }
            try {
                let guildKeyData = JSON.parse(await this.crypto.fetchAndDecrypt(ipfsHash, encryptedContentMetadata));
                let dateE = new Date().getTime();
                time = dateD - dateC;
                resolve(this.crypto.parseGuildKey(guildKeyData));
            } catch (e) {
                console.log("error while decryptoing", e);
                resolve(undefined);
            }
        });
        
        this.guildKeyCache[guildId] = promise;
        return await promise;
    }

    async newGuildWithPeople(name, people, passphrase=uuid()) {
        return new Promise(async (resolve, reject) => {
            let key = await this.crypto.generateGuildKey(passphrase);
            let guildPrivateKey = key.privateKey;
            let guildPublicKey = key.publicKey;
            let encryptedKeyData = await this.crypto.encryptAndUploadJSON(key);
            let encryptedContentKey = encryptedKeyData.encryptedContentKey;
            let encryptedContentIpfsHash = encryptedKeyData.encryptedContentIpfsHash;
            let publicKey = encryptedKeyData.publicKey;

            let encryptedKeyIpfsHashes = [];
            let contentKeys = [];
            let userPublicKeys = [];

            for (let user of people) {
                let _publicKey = await this.encryption.getPublicKey(user);
                let _encryptedKeyData = await this.crypto.encryptAndUploadJSON(key, _publicKey);
                let _contentKey = _encryptedKeyData.contentKey;

                encryptedKeyIpfsHashes.push(ipfsHashToBytes32(_encryptedKeyData.encryptedContentIpfsHash));
                contentKeys.push(_contentKey.convertForEthereum());
                userPublicKeys.push(_contentKey.getPublicKeyAsBytes32());
            }

            // now have everyting to call newGuild
            new EthereumTransaction(
                GUILD_SETTINGS,
                'createGuildWithPeople',
                [
                    guildPublicKey,
                    name,
                    // people,
                    ipfsHashToBytes32(encryptedContentIpfsHash),
                    encryptedContentKey,
                    publicKey,
                    /*
                    encryptedKeyIpfsHashes,
                    contentKeys,
                    userPublicKeys
                    */
                ])
                .execute()
                .then(x => {
                    resolve();
                });
        });
    }

    async newGuild(name, passphrase=uuid()) {
        return new Promise(async (resolve, reject) => {
            let key = await this.crypto.generateGuildKey(passphrase);
            let guildPrivateKey = key.privateKey;
            let guildPublicKey = key.publicKey;
            
            let encryptedKeyData = await this.crypto.encryptAndUploadJSON(key);
            let encryptedContentKey = encryptedKeyData.encryptedContentKey;
            let encryptedContentIpfsHash = encryptedKeyData.encryptedContentIpfsHash;
            let publicKey = encryptedKeyData.publicKey;
            
            // now have everyting to call newGuild
            new EthereumTransaction(
                GUILDS,
                'newGuild',
                [
                    guildPublicKey,
                    name,
                    ipfsHashToBytes32(encryptedContentIpfsHash),
                    encryptedContentKey,
                    publicKey])
                .execute()
                .then(x => {
                    resolve(key);
                });
        });
    }

    requestToAddMember(guildId, user) {
        return new Promise(async (resolve, reject) => {
            let key = await this.getGuildKey(guildId);
            let publicKey = await this.encryption.getPublicKey(user);
            let encryptedKeyData = await this.crypto.encryptAndUploadJSON(key, publicKey);
            let contentKey = encryptedKeyData.contentKey;
            new EthereumTransaction(
                GUILDS,
                'requestToAddMember',
                [
                    guildId,
                    user,
                    ipfsHashToBytes32(encryptedKeyData.encryptedContentIpfsHash),
                    contentKey.convertForEthereum(),
                    contentKey.getPublicKeyAsBytes32()
                ])
                .execute()
                .then(s => {
                    resolve();
                });
        });
    }

    leaveGuild(guildId) {
        return new Promise(async (resolve, reject) => {
            new EthereumTransaction(
                GUILD_SETTINGS,
                'leaveGuild',
                [guildId])
                .execute()
                .then(r => {
                    resolve();
            });
        });
    }

    voteForProposal(guildId, proposalIndex, vote) {
        return new Promise(async (resolve, reject) => {
            this.contract.methods.voteOnNewGuildMemberProposal(guildId, proposalIndex, vote).send({
                from: await accounts.getAccount()
            }, (error, transactionHash) => {
                if (error) {
                    reject(error);
                } else {
                    resolve();
                }
            });
        });
    }

    getAllGuildMemberProposals() {
        return new Promise(async (resolve, reject) => {
            let guilds = await this.getGuildsForUser();

            let proposals = [];
            for (let i in guilds) {
                let guildId = guilds[i].guildId;
                let guildProposals = await this.getGuildMemberProposals(guildId);
                for (let i in guildProposals) {
                    proposals.push({
                        guildId: guildId,
                        proposalIndex: i,
                        potentialMember: guildProposals[i]
                    });
                }
            }

            resolve(proposals);
        });
 
    }

    getGuildMemberProposals(guildId) {
        return new Promise(async (resolve, reject) => {
            const accounts = await this.web3.eth.getAccounts();
            let totalProposals = await this.contract.methods
                .getTotalGuildMemberProposals(guildId).call({from: accounts[0]});

            let proposals = [];
            for (let i=0; i < totalProposals; i++) {
                let proposal = await this.contract.methods
                    .getNewGuildMemberProposal(guildId, i).call({from: accounts[0]});
                proposals.push(proposal);
            }

            resolve(proposals);
        });
 
    }

    get contractAddress() {
        return this.contract.options.address;
    }

    async getNewMemberRequestsFromGuild(guildId) {
        const account = await accounts.getAccount();
        if (account === undefined) {
            return [];
        }

        let requests = await new BackendQuery(this.contractAddress)
            .from(NewGuildMemberRequest)
            .select('newMember')
            .where('guildId', guildId)
            .executeQuery(false);

        let accepts = await new BackendQuery(this.contractAddress)
            .from(NewGuildMemberRequestAccepted)
            .select('newMember')
            .where('guildId', guildId)
            .executeQuery(false);

        let rejects = await new BackendQuery(this.contractAddress)
            .from(NewGuildMemberRequestRejected)
            .select('newMember')
            .where('guildId', guildId)
            .executeQuery(false);
        
        let z = requests.filter(
            x => !accepts.some(y => x.newMember === y.newMember) &&
                !rejects.some(y =>x.newMember === y.newMember));

        return z;
    }

    async acceptAnyNewRequests() {
        if (!accounts.isLoggedIn()) {
            return;
        }
        let requests = await this.getNewMemberRequests();
        requests.forEach(
            ({guildId}) =>
                this.acceptRequestToAddToGuild(guildId));
    }

    getNewMemberRequests() {
        return new Promise(async (resolve, reject) => {
            const account = await accounts.getAccount();
            if (account === undefined) {
                resolve([]);
                return;
            }
            let requestingGuilds = await new BackendQuery(this.contractAddress)
                .from(NewGuildMemberRequest)
                .select('guildId')
                .select('requester')
                .where('newMember', account.toLowerCase())
                .executeQuery(false);


            let map = {};
            for (let i in requestingGuilds) {
                map[requestingGuilds[i].guildId] = {
                    requester: requestingGuilds[i].requester,
                    blockNumber: requestingGuilds[i].blockNumber};
            }

            map = this.reduceMap(map);

            let acceptedGuilds = await new BackendQuery(this.contractAddress)
                .from(NewGuildMemberRequestAccepted)
                .select('guildId')
                .where('newMember', account.toLowerCase())
                .executeQuery(false);

            acceptedGuilds = acceptedGuilds.map(x => x.guildId);

            let rejectedGuilds = await new BackendQuery(this.contractAddress)
                .from(NewGuildMemberRequestRejected)
                .select('guildId')
                .where('newMember', account.toLowerCase())
                .executeQuery(false);

            rejectedGuilds = rejectedGuilds.map(x => x.guildId);

            // only show requests that haven't been accepted already
            let requests = [];
            for (let i in map) {
                let accepted = this.countOccurences(acceptedGuilds, parseInt(i));
                let rejected  = this.countOccurences(rejectedGuilds, parseInt(i));
                if (map[i].count > accepted + rejected) {
                    requests.push({
                        guildId: parseInt(i),
                        guildName: await this.getGuildName(parseInt(i)),
                        requester: map[i].requester,
                        blockNumber: map[i].blockNumber});
                }
            }

            resolve(requests);
        });
    }

    reduceMap(map) {
        let finalMap = {};

        for (let i in map) {
            for (let j in finalMap) {
                if (j === i) {
                    finalMap[j].count++;
                    continue;
                }
            }
            finalMap[i] = map[i];
            finalMap[i].count = 1;
        }

        return finalMap;
    }

    countOccurences(list, i) {
        let count = 0;
        for (let x in list) {
            if (list[x] === i) {
                count++;
            }
        }
        return count;
    }

    rejectRequestToAddToGuild(guildId) {
        return new Promise(async (resolve, reject) => {
            new EthereumTransaction(
                GUILDS,
                'rejectRequestToAddToGuild',
                [guildId]).execute()
                .then(r => {
                    resolve();
                });
        });
    }

    acceptRequestToAddToGuild(guildId) {
        return new Promise(async (resolve, reject) => {
            new EthereumTransaction(
                GUILDS,
                'acceptRequestToAddToGuild',
                [guildId]).execute()
                .then(r => {
                    resolve();
                });
        });
    }

    getAllMembersInUsersGuilds(user) {
        return new Promise(async (resolve, reject) => {
            const account = await accounts.getAccount();
            let guilds = await this.getGuildsForUser(user);
            let allMembers = [];
            for (let i in guilds) {
                let guild = guilds[i];
                let guildId = guild.guildId;
                let members = await this.getUsersInGuild(guildId);
                members = members.filter(x => x.userId !== account);
                members = members.map(member => ({
                    ... member,
                    guildId: guildId,
                    guildName: guild.name
                }));
                allMembers = allMembers.concat(members);
            }

            resolve(allMembers);
        });
    }

    async getGuildsUserLeft(user) {
        if (!user) {
            user = await accounts.getAccount();
        }
        let query = new BackendQuery(guildSettingsAddress)
            .from(UserLeftGuild)
            .select("guildId");
        
        let results = await query.executeQuery();
        return results.map(x => x.guildId);
    }

    getGuildsForUser(user, useBackend=true) {
        return new Promise(async (resolve, reject) => {
            const address = await accounts.getAccount();

            if (user === undefined) {
                user = address;
            }

            if (user === undefined) {
                resolve([]);
                return;
            }

            let guildsUserLeft = await this.getGuildsUserLeft(address);
            
            let guilds = [];

            let query = new BackendQuery(this.contract.options.address)
                .from(GuildKeyEncrypted)
                .select('guildId')
                .where('user', user.toLowerCase());

            let results = await query.executeQuery(false);

            let guildsMap = {};
            for (let i in results) {
                let guildId = results[i]['guildId'];
                let guildName = await this.getGuildName(guildId);
                guildsMap[guildId] = guildName;
            }

            let ret = Object.keys(guildsMap)
                .filter(guildId => !guildsUserLeft.includes(parseFloat(guildId)))
                    .map(guildId => ({
                        guildId: parseInt(guildId),
                        name: guildsMap[guildId]
                    }));
            resolve(ret);
        });
    }

    async hasAccessTo(guildId) {
        if (guildId === 0) {
            return true;
        }
        let guildIds = await this.getGuildsWithAccess();
        return guildIds.indexOf(guildId) > -1;
    }

    getGuildsWithAccess(user) {
        return new Promise(async (resolve, reject) => {
            if (this.guildsWithAccess !== undefined) {
                resolve(this.guildsWithAccess);
                return;
            }
            const address = await accounts.getAccount();

            if (user === undefined) {
                user = address;
            }

            if (user === undefined) {
                this.guildsWithAccess = [];
                resolve([]);
                return;
            }
            
            let guilds = [];

            let query = new BackendQuery(this.contract.options.address)
                .from(GuildKeyEncrypted)
                .select('guildId')
                .where('user', user.toLowerCase());

            let results = await query.executeQuery(false);

            this.guildsWithAccess = Array.from(new Set(results.map(ret => ret.guildId)));
            resolve(this.guildsWithAccess);
        });
    }

    async getGuildName(guildId) {
        if (!guildId) {
            return '';
        }
        if (guildId in nameCache) {
            return await nameCache[guildId];
        }
        let promise = new Promise(async (resolve, reject) => {
            let query = new BackendQuery(this.contract.options.address)
                .from(NewGuild)
                .select('name')
                .where('guildId', guildId);
            
            let results = await query.executeQuery(false);
            if (results.length === 0) {
                return '';
            }
            resolve(results[0].name);
        });
        nameCache[guildId] = promise;
        return await promise;
    }

    getUsersInGuild(guildId) {
        return new Promise(async (resolve, reject) => {
            if (!navigator.onLine) {
                resolve([]);
                return;
            }
            const address = await accounts.getAccount();
            let users = [];
            try {
                let numMembers = await this.contract.methods.getTotalGuildUsers(guildId).call()
                for (let i=0; i < numMembers; i++) {
                    let userId = await this.contract.methods.getUserFromGuild(guildId, i).call()
                    let userName = await this.users.getUserName(userId);
                    users.push({userId: userId, userName: userName});
                }
            } catch (err) {
            }

            resolve(users);
        });
    }

    setGuildName(guildId, name) {
        return new Promise(async (resolve, reject) => {
            const accounts = await this.web3.eth.getAccounts();
            this.contract.methods.setNameForGuild(guildId, name).send({
                from: accounts[0] 
            }, (error, transactionHash) => {
                if (error) {
                    reject(error);
                } else {
                    resolve();
                }
            });
        
        });
    }

    async getContentGuildId(hash, contentType) {
        if (hash in this.guildIdCache) {
            return this.guildIdCache[hash];
        }

        if (contentType === SOUND) {
            // get guild id for sound
            let query = new BackendQuery(samplesContract.contractAddress)
                .from(SampleCreated)
                .select('guildId')
                .where('ipfsHash', hash);

            let results = await query.executeQuery(false);
            if (results.length === 0) {
                this.guildIdCache[hash] = 0;
                return 0;
            }
            
            let guildId = results[0].guildId;
            guildId = guildId === null || guildId === undefined ? 0 : guildId;
            this.guildIdCache[hash] = guildId;
            return guildId;
        } else {
            let sequence = await ethereum.guildSequences.getGuildSequence(hash);
            if (sequence) {
                return sequence.guildId;
            }
        }

        return 0;
    }

    onUserChanged() {
        this.guildsWithAccess = undefined;
        this.getGuildsWithAccess();
    }

    async getPeople() {
        let results = await new BackendQuery(this.contractAddress)
            .from(GuildKeyEncrypted)
            .select('user')
            .executeQuery();

        let people = [];
        for (let i in results) {
            let id = results[i].user;
            let userName = await this.users.getUserName(id);
            people.push({
                id,
                userName
            });
        }
        return people;
    }
}

export default Guilds;
